export default __webpack_public_path__ + "static/media/interface.a06f8881.png";